import { Schema as QuoterSchema } from "@comparaonline/quoter-schema";
import { isInsuranceByKm } from "./isInsuranceByKm";

export const getFeatured = (product: QuoterSchema.Product) => {
  const insuranceByKMProps = {
    mainColor: "#A92323",
    contrastColor: "white",
    label: "Seguro por KM"
  };

  return isInsuranceByKm(product) ? insuranceByKMProps : undefined;
};
